// src/supabaseClient.js

import { createClient } from "@supabase/supabase-js";

// Retrieve keys from environment variables (REACT_APP prefix required for create-react-app)
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Optional: Add a check for debugging purposes
if (!supabaseUrl || !supabaseAnonKey) {
  console.error("Supabase keys are missing. Please ensure your .env file is set up correctly.");
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
